import clsx from "clsx";
import { PropsWithChildren } from "react";
import RLCard from "../../../../components/card/RLCard";

import styles from "./common.module.scss";

type Props = {
  className?: string;
};

const NetworkThreatError = ({
  children,
  className
}: PropsWithChildren<Props>) => (
  <RLCard.NoData className={clsx(styles.no_data, className)}>
    {children}
  </RLCard.NoData>
);

export default NetworkThreatError;
